module.exports = __webpack_public_path__ + "static/media/target_widget_icon.597f286a.svg";